function formatWithSuffix(value, suffix) {
  const scaled = value / suffix.divisor;
  const digits = scaled % 1 === 0 ? 0 : 2;
  return `${scaled.toFixed(digits)}${suffix.symbol}`;
}

export function formatNumber(input) {
  const value = Number(input);

  if (!Number.isFinite(value)) {
    return '0';
  }

  const absoluteValue = Math.abs(value);

  if (absoluteValue <= 999) {
    return `${value}`;
  }

  const suffixes = [
    { divisor: 1_000_000_000, symbol: 'B' },
    { divisor: 1_000_000, symbol: 'M' },
    { divisor: 1_000, symbol: 'K' },
  ];

  const matchedSuffix = suffixes.find(item => absoluteValue >= item.divisor);

  if (!matchedSuffix) {
    return `${value}`;
  }

  return formatWithSuffix(value, matchedSuffix);
}

export default formatNumber;
